"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ParamParsers_1 = require("../../core/utils/ParamParsers");

var PromotionWeekType_1 = require("../../promotion/enums/PromotionWeekType");

var PromotionSelectEnum_1 = require("../../promotion/model/PromotionSelectEnum");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var PromotionOverviewFilter_1 = require("../model/PromotionOverviewFilter");

var PromotionOverviewFilterConverter_1 = require("./PromotionOverviewFilterConverter");
/**
 * @author Radek Beran
 */


var PromotionOverviewFilterConverterImpl =
/*#__PURE__*/
function (_PromotionOverviewFil) {
  _inherits(PromotionOverviewFilterConverterImpl, _PromotionOverviewFil);

  function PromotionOverviewFilterConverterImpl() {
    _classCallCheck(this, PromotionOverviewFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionOverviewFilterConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionOverviewFilterConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromotionOverviewFilter_1.PromotionOverviewFilter(utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'ids')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'states', PromotionStateEnum_1.PromotionStateEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'filter')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseEnumValue(source, 'select', PromotionSelectEnum_1.PromotionSelectEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'storeSpecifications', StoreSpecificationEnum_1.StoreSpecificationEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'promotionTypeIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseEnumValue(source, 'promotionWeekType', PromotionWeekType_1.PromotionWeekType)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseArrayOfNumbers(source, 'weeks')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseArrayOfNumbers(source, 'years')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'themeIds')), source.dateToGte ? conversions.toDate(source.dateToGte) : undefined);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        ids: !utils_1.Utils.isValueMissing(source.ids) ? source.ids.toArray() : undefined,
        states: !utils_1.Utils.isValueMissing(source.states) ? source.states.toArray() : undefined,
        filter: source.filter,
        select: source.select,
        storeSpecifications: !utils_1.Utils.isValueMissing(source.storeSpecifications) ? source.storeSpecifications.toArray() : undefined,
        promotionTypeIds: !utils_1.Utils.isValueMissing(source.promotionTypeIds) ? source.promotionTypeIds.toArray() : undefined,
        promotionWeekType: source.promotionWeekType,
        weeks: source.weeks,
        years: source.years,
        themeIds: !utils_1.Utils.isValueMissing(source.themeIds) ? source.themeIds.toArray() : undefined,
        dateToGte: !utils_1.Utils.isValueMissing(source.dateToGte) ? conversions.fromDate(source.dateToGte) : undefined
      });
      return result;
    }
  }]);

  return PromotionOverviewFilterConverterImpl;
}(PromotionOverviewFilterConverter_1.PromotionOverviewFilterConverter);

exports.PromotionOverviewFilterConverterImpl = PromotionOverviewFilterConverterImpl;